import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { MenuModule } from 'primeng/menu';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AppFooterComponent } from 'src/app/components/footer/app.footer.component';
import { AppTopBarComponent } from 'src/app/components/topbar/app.topbar.component';
import { AppBreadcrumbComponent } from 'src/app/shared/utilities/app.breadcrumb.component';
import { AppConfigComponent } from 'src/app/shared/utilities/app.config.component';
import { AppMenuComponent } from 'src/app/shared/utilities/app.menu.component';
import { AppMenuitemComponent } from 'src/app/shared/utilities/app.menuitem.component';
import { AppRightPanelComponent } from 'src/app/shared/utilities/app.rightpanel.component';
import { DisplayComponent } from 'src/app/shared/utilities/display.component';
import { IconsComponent } from 'src/app/shared/utilities/icons.component';
import { SpacingComponent } from 'src/app/shared/utilities/spacing.component';
import { AppBreadcrumbService } from './utilities/app.breadcrumb.service';
import { AppCodeComponent } from './utilities/app.code.component';
import { AppMainComponent } from './utilities/app.main.component';
import { MenuService } from './utilities/app.menu.service';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		NgbModule,
		NgxSpinnerModule,
		RouterModule,
		CheckboxModule,
		ButtonModule,
		RadioButtonModule,
		MenuModule,
	],
	declarations: [
		AppConfigComponent,
		AppMenuComponent,
		AppMenuitemComponent,
		AppRightPanelComponent,
		AppBreadcrumbComponent,
		AppTopBarComponent,
		AppFooterComponent,
		SpacingComponent,
		IconsComponent,
		DisplayComponent,
		AppCodeComponent,
		AppMainComponent,
	],

	exports: [AppCodeComponent],
	providers: [MenuService, AppBreadcrumbService],
})
export class UtilitiesModule {}
